import { GUEST_SCOPE, knownAccountLimits, PlanLimitError } from '../auth/planLimits'
import type { NoteRepository } from '../data/db'

type ImageCounts = Pick<NoteRepository, 'countLiveImages' | 'countImagesOfNote'>

export interface ImageCapacity {
  limit: number
  used: number
  room: number
}

/** Room for more images under the account's plan (a guest's, without an account), or null when there is no limit (or none is known yet). */
export async function imageCapacity(repository: ImageCounts, ownerId: string | null | undefined): Promise<ImageCapacity | null> {
  const limit = knownAccountLimits(ownerId || GUEST_SCOPE)?.images
  if (limit == null) return null
  const used = await repository.countLiveImages()
  return { limit, used, room: Math.max(0, limit - used) }
}

/**
 * Restoring a note from Trash brings its images back into the count. Refuse it while that would take the
 * account over its limit; the person frees images first. The server refuses the same restore as a backstop.
 */
export async function assertRestoreFitsImageLimit(
  repository: ImageCounts,
  ownerId: string | null | undefined,
  noteId: string,
): Promise<void> {
  const capacity = await imageCapacity(repository, ownerId)
  if (!capacity) return
  const returning = await repository.countImagesOfNote(noteId)
  if (returning > capacity.room) {
    throw new PlanLimitError('images', capacity.limit, capacity.used + returning, capacity.used + returning - capacity.limit)
  }
}
